import { useEffect } from 'react'
import { setSentryUserPerhaps } from '@/shared/utils/sentry'
import { useCurrentWebUser } from '@/web-app/providers/current-user-provider'

export function useInitAnalytics() {
  const { currentUser } = useCurrentWebUser()

  useEffect(() => {
    setSentryUserPerhaps(currentUser)
  }, [currentUser])
}
